import { outcomeIdSchema } from './ids';

/**
 * Weekly-plan suggestions (the focus-areas screen). The host emits one outcome
 * per generation attempt so the funnel shows failures directly instead of only
 * the retry tap that followed them. `error_code` on the failed
 * outcome is a closed kebab-case classification — `timeout`, `http-500`,
 * `document-invalid` — never response text.
 */
export const WEEKLY_PLAN_SUGGESTIONS_OUTCOME_IDS = {
  generationSucceeded: outcomeIdSchema.parse('weekly-plan-suggestions.generation.succeeded'),
  generationFailed: outcomeIdSchema.parse('weekly-plan-suggestions.generation.failed'),
} as const;
